import * as React from 'react';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';

type DesignSystemPageSectionProps = {
    title:string,
    children: React.ReactNode | React.ReactNode[];
}
export function DesignSystemPageSection(props:DesignSystemPageSectionProps):JSX.Element
{
    const color = '#646464';

    return (
        <Flex flexDirection={'column'}>
            <h2 style={{color, fontSize:'20px', marginBottom:'0px', height:'22px'}}>{props.title}</h2>
            <Flex flexDirection="row"
                justifyContent='flex-start'
                alignItems='flex-end'
                style={{border:`1px dotted ${color}`, padding:'16px'}}
                gap={16}>
                
                {props.children}

            </Flex>
        </Flex>
    );
}

type DesignSystemVariantSectionProps = {
    title:string,
    children: React.ReactNode | React.ReactNode[];
    width?:string;
}
export function DesignSystemVariantSection(props:DesignSystemVariantSectionProps):JSX.Element
{
    const color = '#A0A0A0';

    return (
        <div style={{
            display: 'inline-flex', 
            flexDirection: 'column', 
            width: props.width ?? 'min-content'}}>

            <span style={{
                color, 
                fontSize:'12px', 
                marginBottom:'0px',
                width: '100%',
                wordWrap: 'break-word',
                overflowWrap: 'break-word'
            }}>{props.title}</span>

            <div style={{border:`1px dotted ${color}`, padding:'16px', width:'100%'}}>

                {props.children}

            </div>
            
        </div>
    );
}